import { writable } from 'svelte/store';
import { fetchWithAuth } from '$lib/utils/http/httpUtil';

export const region = writable<string | null>(null);

export async function loadRegion(): Promise<void> {
    try {
        const res = await fetchWithAuth('/api/region');
        if (res.ok) {
            const data = await res.json();
            region.set(data.country ?? null);
        }
    } catch {
        // non-fatal — banner simply won't show
    }
}
